<template>
  <div class="container-fluid principal">
    <div class="row">
      <div class="col-md-12">
        <Toast position="top-right" :baseZIndex="2222" />
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <Card>
              <template #header> </template>
              <template #title>Change Password</template>
              <template #content>
                <div class="p-fluid">
                  <div class="p-field">
                    <label for="old_password">Current password</label>
                    <Password
                      id="old_password"
                      v-model="old_password"
                      :feedback="false"
                      :toggleMask="true"
                      promptLabel="Enter your password"
                      :class="{
                        'p-invalid': invalid.old_password,
                      }"
                    >
                    </Password>
                    <small class="p-invalid" v-if="invalid.old_password"
                      >Please complete this field.
                    </small>
                    <br />
                    <br />
                  </div>
                  <div class="p-field">
                    <label for="new_password">New Password</label>
                    <Password
                      id="new_password"
                      v-model="new_password"
                      :feedback="true"
                      :toggleMask="true"
                      promptLabel="Please enter a password"
                      weakLabel="Low Security"
                      mediumLabel="Medium Security"
                      strongLabel="High Security"
                      :class="{
                        'p-invalid': invalid.new_password,
                      }"
                    >
                      <template #header>
                        <h6>New Password</h6>
                      </template>
                      <template #footer>
                        <Divider />
                        <p class="p-mt-2">Recommendations</p>
                        <ul
                          class="p-pl-2 p-ml-2 p-mt-0"
                          style="line-height: 1.5"
                        >
                          <li>At least one lowercase</li>
                          <li>At least one capital letter</li>
                          <li>At least one number</li>
                          <li>Minimum 8 characters</li>
                        </ul>
                      </template>
                    </Password>
                    <small class="p-invalid" v-if="invalid.new_password"
                      >Please complete this field.
                    </small>
                    <br />
                    <br />
                  </div>
                  <div class="p-field">
                    <label for="repeated_password"
                      >Repeat New Password</label
                    >
                    <Password
                      id="repeated_password"
                      v-model="repeated_password"
                      :feedback="false"
                      :toggleMask="true"
                      :class="{
                        'p-invalid': invalid.repeated_password,
                      }"
                    ></Password>
                    <small
                      class="p-invalid"
                      v-if="invalid.repeated_password_value"
                      >Please complete this field.
                    </small>
                    <small class="p-invalid" v-if="invalid.diferent_password"
                      >The password entered does not match the new password.
                    </small>
                  </div>
                </div>
              </template>
              <template #footer>
                <div class="p-grid p-jc-center">
                  <div class="p-col-2">
                    <Button
                      v-if="loaded_update"
                      icon="pi pi-user-edit"
                      label="Update"
                      @click="updatePassword"
                    />

                    <ProgressSpinner
                      v-else
                      style="width: 50px; height: 50px"
                      strokeWidth="8"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                  </div>
                </div>
              </template>
            </Card>
          </div>
          <div class="col-md-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import Toast from "primevue/toast";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Card from "primevue/card";
import Password from "primevue/password";
import Divider from "primevue/divider";
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      loaded_update: true,
      old_password: "",
      new_password: "",
      repeated_password: "",
      invalid: {
        new_password: false,
        old_password: false,
        repeated_password_value: false,
        repeated_password: false,
        diferent_password: false,
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    updatePassword() {
      this.invalid.diferent_password =
        this.new_password != this.repeated_password ? true : false;
      this.invalid.repeated_password =
        this.new_password != this.repeated_password ||
        this.repeated_password.trim().length == 0
          ? true
          : false;
      this.invalid.new_password =
        this.new_password.trim().length == 0 ? true : false;
      this.invalid.old_password =
        this.old_password.trim().length == 0 ? true : false;
      this.invalid.repeated_password_value =
        this.repeated_password.trim().length == 0 ? true : false;
      if (
        !this.invalid.diferent_password &&
        !this.invalid.repeated_password &&
        !this.invalid.new_password &&
        !this.invalid.old_password &&
        !this.invalid.repeated_password_value
      ) {
        this.loaded_update = false;
        Auth.currentAuthenticatedUser()
          .then((user) => {
            return Auth.changePassword(
              user,
              this.old_password,
              this.new_password
            );
          })
          .then((data) => {
            this.$toast.add({
              severity: "success",
              summary: "Modified Password",
              detail: "Your password has been changed correctly.",
              life: 5000,
            });
          })
          .catch((err) => {
            if (err.code == "NotAuthorizedException") {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail:
                  "The current password is incorrect, please try again.",
                life: 5000,
              });
            }
          })
          .finally(() => {
            this.old_password = "";
            this.new_password = "";
            this.repeated_password = "";
            this.loaded_update = true;
          });
      }
    },
  },
  components: {
    Toast,
    Button,
    ProgressSpinner,
    Password,
    Card,
    Divider,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available !important;
}
.button-margin-right {
  margin-right: 2px;
}
</style>